{
  "header": {
    "history": "History",
    "viewInvoice": "View invoice"
  },
  "suggestions": {
    "greeting": "What can I help with today?",
    "subtitle": "Tap a suggestion to start — I can draft invoices, log expenses, look up clients, and more.",
    "categories": {
      "invoice": "Invoices",
      "expense": "Expenses & revenue",
      "client": "Clients & receivables",
      "tax": "Books & reports"
    }
  },
  "input": {
    "attach": "Attach file",
    "dropFiles": "Drop files to upload",
    "placeholder": "Paste a message or type a request to create an invoice...",
    "enterToSend": "send",
    "shiftEnterNewline": "new line",
    "fileHint": "add a file",
    "dismissFileHint": "Dismiss file hint"
  },
  "actions": {
    "editManual": "Edit manually",
    "approveQR": "Approve & Create VietQR",
    "sendZalo": "Send via Zalo",
    "copyJSON": "Copy JSON",
    "regenerate": "Regenerate"
  },
  "artifact": {
    "title": "Invoice Preview",
    "draft": "Draft",
    "close": "Close",
    "missingInfo": "Missing information:",
    "helpText": "You can continue chatting to make edits, or click \"Approve\" to create a VietQR and send it to your client.",
    "emptyTitle": "Send a message to create an invoice.",
    "emptySubtitle": "The invoice will appear here.",
    "viewInvoice": "View invoice #{{id}}",
    "approving": "Processing...",
    "editManual": "Edit manually",
    "downloadPDF": "Download PDF",
    "invoice": "Invoice",
    "createdDate": "Created",
    "client": "Client",
    "details": "Details",
    "subtotal": "Subtotal",
    "vat": "VAT ({{rate}}%)",
    "deposit": "Deposit",
    "balance": "Balance due",
    "vietqr": "VietQR",
    "paymentRef": "Payment ref:",
    "qrPending": "QR will be generated after approval",
    "unknownClient": "Unknown",
    "sendEmail": "Send via email",
    "markZalo": "Mark as sent via Zalo",
    "sendReminder": "Send reminder",
    "openInvoice": "Open invoice detail",
    "draftLabel": "Draft #{{n}}",
    "approveFailed": "Approve failed, try again",
    "extrasLocked": "Extra sales are available on Pro. Upgrade to enable.",
    "marked": "Marked",
    "markFailed": "Failed to mark, try again",
    "cancel": "Cancel",
    "prev": "Previous invoice",
    "next": "Next invoice",
    "markZaloConfirm": {
      "title": "Mark as sent via Zalo?",
      "body": "This transitions the invoice to 'Pending payment' status. Use when you've shared the link/QR with the customer via Zalo.",
      "action": "Confirm"
    },
    "qrBankNotLinked": "No bank account linked — payment QR couldn't be generated.",
    "qrUnsupportedBank": "This bank isn't supported for VietQR yet.",
    "linkBank": "Link bank account",
    "qrRetry": "Retry",
    "qrRetrying": "Retrying...",
    "bankWarn": {
      "title": "No bank account linked",
      "body": "A payment QR needs a linked bank account. Link one in Settings → Bank, or create the invoice anyway (no QR yet — you can add it after linking).",
      "link": "Link bank account",
      "proceed": "Create anyway"
    }
  },
  "threads": {
    "title": "Conversations",
    "empty": "No conversations yet",
    "newConversation": "New conversation"
  }
}
